import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../lib/LanguageContext';
export function FundingPathways() {
  const {
    t,
    tArray
  } = useLanguage();
  const regions = [{
    name: 'Canada',
    accent: '🍁'
  }, {
    name: 'USA',
    accent: '🦅'
  }, {
    name: 'Mexico',
    accent: '🌵'
  }, {
    name: 'International',
    accent: '🌍'
  }];
  const opportunities = tArray<string>('fundingPathways.opportunities');
  return <section className="py-24 md:py-32 bg-sandstone relative" id="support" data-id="element-65">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-66">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-67">
          <h2 className="text-3xl md:text-5xl font-heading text-navy mb-4" data-id="element-68">
            {t('fundingPathways.title')}
          </h2>
          <p className="text-navy/70 text-lg" data-id="element-69">
            {t('fundingPathways.subtitle')}
          </p>
        </motion.div>

        {/* Regional Donations */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-70">
          {regions.map((region, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-ivory p-8 rounded-sm border border-gold/20 text-center flex flex-col justify-between h-full hover:shadow-lg hover:border-saffron/50 transition-all" data-id="element-71">
              <div data-id="element-72">
                <div className="text-2xl mb-4 opacity-80" data-id="element-73">{region.accent}</div>
                <h3 className="font-heading text-xl text-navy mb-2" data-id="element-74">
                  {t('fundingPathways.donateFrom')} {region.name}
                </h3>
              </div>
              <button className="mt-6 w-full py-3 border border-navy/20 text-navy/50 rounded-sm text-xs tracking-widest uppercase font-medium cursor-not-allowed" data-id="element-75">
                {t('fundingPathways.comingSoon')}
              </button>
            </motion.div>)}
        </div>

        {/* Other Opportunities */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="bg-navy text-ivory p-8 md:p-12 rounded-sm border border-gold/30" data-id="element-76">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left divide-y md:divide-y-0 md:divide-x divide-gold/20" data-id="element-77">
            <div className="space-y-6" data-id="element-78">
              {opportunities.map((opp, idx) => <div key={idx} className="flex flex-col sm:flex-row sm:items-center justify-between p-4 rounded-sm bg-navy/20 border border-warmWhite/5 hover:border-saffron/30 transition-colors" data-id="element-79">
                  <h4 className="text-warmWhite font-medium mb-2 sm:mb-0" data-id="element-80">
                    {opp}
                  </h4>
                  <a href="https://wa.me/6596670750" target="_blank" rel="noopener noreferrer" className="text-saffron text-sm tracking-widest uppercase font-medium hover:text-warmWhite transition-colors flex items-center group" data-id="element-81">
                    {t('fundingPathways.inquireCta')}
                    <span className="ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-82">
                      →
                    </span>
                  </a>
                </div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}